import React from "react";

import NumericInput from "../../common/inputs/NumericInput";
import { ICountParamTypeDescriptor } from '../../database/interfaces/paramScript/IParamTypeDescriptor';

/**
 * Count property card content component.
 */
interface ICountCardContentProps {
    typeDescriptor: ICountParamTypeDescriptor;
    paramValue: string;
    onUpdateParamValue: (value: string) => void;
}

const CountCardContent: React.FC<ICountCardContentProps> = ({ typeDescriptor, paramValue, onUpdateParamValue }) => {
    const value = React.useMemo<number>(() => {
        return parseInt(paramValue as string, 10);
    }, [paramValue]);

    const handleValueChange = (newNum: number) => {
        onUpdateParamValue(newNum.toString());
    };

    return typeDescriptor && (
        <NumericInput
            label={typeDescriptor.label || ""}
            value={value || 0}
            min={typeDescriptor.config?.min || 0}
            max={typeDescriptor.config?.max || 1000}
            smallStep={typeDescriptor.config?.smallStep || 1}
            largeStep={typeDescriptor.config?.largeStep || 5}
            tooltip={typeDescriptor.tooltip}
            placeholder={typeDescriptor.placeholder}
            editable={typeDescriptor.editable ?? true}
            readOnly={typeDescriptor.readOnly ?? false}
            onValueChanged={handleValueChange}
        />
    );
}

export default CountCardContent;
